import type { ColorItem } from "../types";

export const COLORS: ColorItem[] = [
    { color: "transparent" },
    { color: "#111111" },
    { color: "#e03e1a" },
    { color: "#f79722" },
    { color: "#f3c11b" },
    { color: "#198f51" },
    { color: "#0c8de9" },
    { color: "#8a38f5" },
    { color: "#ffffff" },
    { color: "#383838" },
    { color: "#d9d9d9" },
    { color: "#fbbcb6" },
    { color: "#ffc470" },
    { color: "#f9df90" },
    { color: "#a1e8b9" },
    { color: "#a8d7fa" },
    { color: "#d6b6fb" },
    {
        color: "radial-gradient(50% 50% at 50% 50%,#ffffff 0%,transparent 100%),conic-gradient(from 0deg at 50% 50%,#ff0000 0deg,#ffa800 47.73deg,#ffff00 79.56deg,#00ff00 121.33deg,#00ffff 180.99deg,#0000ff 238.67deg,#ff00ff 294.36deg,#ff0000 360deg),#c4c4c4",
        isPicker: true,
    },
];
